// Entity cell values: `company-<id>` for the company or a related entity, `alias-<id>` for an acquired alias.
export interface LedgerEntity {
  entity_company?: number | null;
  entity_alias?: number | null;
}

export const toEntityValue = ({ entity_company, entity_alias }: LedgerEntity): string | null => {
  if (entity_alias) {
    return `alias-${entity_alias}`;
  }
  return entity_company ? `company-${entity_company}` : null;
};

// An alias row is still booked on the cap table's own company, so decoding it needs that company id.
export const fromEntityValue = (value: unknown, companyId?: number | null): Required<LedgerEntity> | null => {
  const [kind, rawId] = typeof value === 'string' ? value.split('-') : [];
  const id = Number(rawId);
  if (!id) {
    return null;
  }
  if (kind === 'company') {
    return { entity_company: id, entity_alias: null };
  }
  return kind === 'alias' && companyId ? { entity_company: companyId, entity_alias: id } : null;
};

// No active entity chips: every row is shown. Shared so the empty filter keeps one identity.
export const NO_ENTITY_FILTER: string[] = [];

export const isRowInEntityFilter = (row: LedgerEntity, activeEntities: string[]) =>
  !activeEntities.length || activeEntities.includes(toEntityValue(row) ?? '');
